import _ from 'lodash'
export default {
  methods: {
    $puedo (permiso) {
      if (this.$store.getters.getPermisos === 'pacientes_agenda:lectura') {
        this.$store.getters.getPermisos.indexOf(permiso)
      }
      return this.$store.getters.getPermisos.indexOf(permiso) !== -1
    },
    $puedoModulo (modulo) {
      return _.find(this.$store.getters.getPermisos, o => {
        let split = o.split('_')

        return split[0] === modulo
      })
    },
    $puedoAlguno (permisos) {
      return _.intersection(this.$store.getters.getPermisos, permisos).length > 0
    }
  }
}
